<template>
  <v-footer
    id="mhr-footer"
    color="mhr-blue"
    class="mhr-footer mhr-white--text"
  >
    <v-container>
      <v-row no-gutters class="text-center text-lg-start">
        <v-col cols="12" lg="7" class="mb-13 d-flex flex-column align-center align-lg-start pe-lg-13">
          <v-img
            contain
            class="mhr-footer-logo"
            src="/assets/logo/mhr-white.svg"
          />
        </v-col>
        <v-col cols="12" lg="5" class="mb-13">
          <div class="mhr-text-h3 mhr-font mb-lg-8 mb-6">Keep in touch</div>
          <div class="d-flex flex-column flex-lg-row mb-2 mb-lg-2">
            <v-text-field
              dense hide-details single-line flat solo
              color="mhr-blue"
              label="insert your email"
              class="mhr-footer-field rounded-0 mhr-white--text"
            />
            <div class="d-lg-none mhr-text-body-3 mb-8 mt-2"> Sign up and get to know first our special offers and news.</div>
            <v-btn
              tile elevation="0" color="mhr-blue" outlined
              class="ms-lg-2 mhr-footer-btn mhr-white--text"
            >
              Subscribe
            </v-btn>
          </div>
          <div class="d-none d-lg-flex mhr-text-body-3"> Sign up and get to know first our special offers and news.</div>
        </v-col>
        <v-col cols="12" lg="4" class="mb-13 pe-lg-13">
          <div class="mhr-text-h3 mhr-font mb-lg-8 mb-6">Contact us</div>
          <div class="mb-6 font-weight-bold">megaworld@megaworld.com</div>
          <div class="mhr-text-body-2">
            <strong>Global One Hotel Group</strong><br>
            Inc 22nd Floor, Alliance Global Tower,<br>
            36th Street corner 11th Avenue,<br>
            Uptown Bonifacio, Taguig City 1634
          </div>
        </v-col>
        <v-col cols="12" lg="3" class="mb-13 pe-lg-13 d-flex flex-column">
          <div class="mhr-text-h3 mhr-font mb-lg-8 mb-6">Company</div>
          <div class="d-flex flex-lg-column justify-space-between flex-grow-1">
            <div class="flex-grow-1 d-flex flex-column justify-space-around">
              <router-link to="/about-us" class="mhr-white--text mb-4 mb-lg-0">About Us</router-link>
              <router-link to="/careers" class="mhr-white--text">Careers</router-link>
            </div>
            <div class="flex-grow-1 d-flex flex-column justify-space-around">
              <router-link to="/promotions" class="mhr-white--text mb-4 mb-lg-0">Promotions</router-link>
              <router-link to="/data-privacy" class="mhr-white--text">Data Privacy</router-link>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="mb-13 d-flex flex-column">
          <div class="mhr-text-h3 mhr-font mb-lg-8 mb-6">Follow us</div>
          <div class="d-flex justify-center justify-lg-start">
            <v-btn
              fab color="mhr-white"
              class="mhr-social-btn elevation-0 me-4"
              href="#" target="_blank" rel="noopener nofollow"
            >
              <v-icon color="mhr-blue">mdi-twitter</v-icon>
            </v-btn>
            <v-btn
              fab color="mhr-white"
              class="mhr-social-btn elevation-0 me-4"
              href="#" target="_blank" rel="noopener nofollow"
            >
              <v-icon color="mhr-blue">mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              fab color="mhr-white"
              class="mhr-social-btn elevation-0 me-4"
              href="#" target="_blank" rel="noopener nofollow"
            >
              <v-icon color="mhr-blue">mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              fab color="mhr-white"
              class="mhr-social-btn elevation-0 me-4"
              href="#" target="_blank" rel="noopener nofollow"
            >
              <v-icon color="mhr-blue">mdi-youtube</v-icon>
            </v-btn>
          </div>
          <v-spacer />
          <div class="mhr-text-body-2 mt-16">
            Copyright {{ new Date().getFullYear() }} &copy; Archipelago International
          </div>
        </v-col>

        <!-- <v-col
          class="text-center text-md-right"
          cols="12"
          md="6"
        >
          Copyright &copy; {{ new Date().getFullYear() }} Vuetify, LLC
        </v-col> -->
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      social: [
        'Facebook',
        'Twitter',
        'Instagram',
        'Linkedin'
      ]
    })
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
